/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 16.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import DataProvider from "../../../DataProvider";
import SchemaValueFormatter from "../../../SchemaValueFormatter";

class ViewText extends React.Component {
    static propTypes = {
        dataProvider: PropTypes.instanceOf(DataProvider).isRequired,
        field: PropTypes.string.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let formatter = new SchemaValueFormatter(this.props.dataProvider.getSchema().field(this.props.field));
        return (
            <span>
                {formatter.format(this.props.dataProvider.getValue(this.props.field))}
            </span>
        );
    }
}

export default ViewText;
